import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './CustomCalendar.css';
import {
  isSameDay,
  isBefore,
  isAfter,
  isWeekend,
} from 'date-fns';

const CustomCalendar = ({ startDate, endDate, setDateRange }) => {
  const [selectingStart, setSelectingStart] = useState(true);

  const isInRange = (date) => {
    if (!startDate || !endDate || isWeekend(date)) return false;
    return isAfter(date, new Date(startDate)) && isBefore(date, new Date(endDate));
  };

  const isStart = (date) => startDate && isSameDay(date, new Date(startDate));
  const isEnd = (date) => endDate && isSameDay(date, new Date(endDate));

  const handleDateClick = (date) => {
    if (isWeekend(date)) return;

    if (selectingStart) {
      setDateRange([date, null]); 
      setSelectingStart(false);
    } else {
      const newStart = new Date(startDate);
      const newEnd = new Date(date);
      if (newEnd < newStart) {
        setDateRange([date, null]);
      } else {
        setDateRange([startDate, date]); 
        setSelectingStart(true); 
      }
    }
  };

  const tileClassName = ({ date, view }) => {
    if (view !== 'month') return null;
    if (isWeekend(date)) return null;
    if (isStart(date)) return 'start-date';
    if (isEnd(date)) return 'end-date';
    if (isInRange(date)) return 'in-range';
    return null;
  };

  return (
    <div className="calendar-section">
      <h3 className="calendar-header">Calendar</h3>
      <div className="calendar-wrapper">
        <Calendar
          calendarType="gregory"
          tileClassName={tileClassName}
          tileDisabled={({ date, view }) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return view === 'month' && date < today;
          }}
          value={startDate ? new Date(startDate) : new Date()}
          showNavigation={true}
          onClickDay={handleDateClick}
          formatShortWeekday={(locale, date) =>
            ['S', 'M', 'T', 'W', 'T', 'F', 'S'][date.getDay()]
          }
          navigationLabel={({ date, locale }) =>
            date.toLocaleDateString(locale, { month: 'long', year: 'numeric' })
          }
          next2Label={null}
          prev2Label={null}
        />
      </div>
    </div>
  );
};

export default CustomCalendar;
